"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import ErrorPage from "@/components/entities/error";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("errorPage");

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorPage
      title={t("title")}
      text={error.message || t("unexpected")}
      actionLabel={t("actions.retry")}
      onAction={reset}
    />
  );
}
